import React, { useState, useEffect, useContext } from "react";
import QRCode from "react-qr-code";
import { api } from "../../api";
import Ctx from "../../contexts/AppContext";
import { inpS, btnP, btnSec, crd, bdg } from "../../constants/styles";
import PhotoUpload from "./PhotoUpload";

function SpJobDetail({ sp }) {
  const { t, h, go, flash, selMaintId } = useContext(Ctx);
  const spJobs = sp.data?.jobs || []; const spTens = sp.data?.tens || []; const spProps = sp.data?.props || [];
  const foundJob = spJobs.find(x => x.id === selMaintId);
  const [job, setJob] = useState(foundJob || null);
  const [notes, setNotes] = useState(foundJob?.sp_notes || "");
  const [photoBefore, setPhotoBefore] = useState(foundJob?.photo_before || null);
  const [photoAfter, setPhotoAfter] = useState(foundJob?.photo_after || null);
  const [showQR, setShowQR] = useState(foundJob?.sp_status === 'completed');
  const [spPayAmt, setSpPayAmt] = useState(foundJob?.sp_pay_amt || "");
  const [spPayNotes, setSpPayNotes] = useState(foundJob?.sp_notes || "");
  const [chargesSaved, setChargesSaved] = useState(false);

  useEffect(() => {
    if (foundJob) { setJob(foundJob); setNotes(foundJob.sp_notes || ""); setPhotoBefore(foundJob.photo_before || null); setPhotoAfter(foundJob.photo_after || null); if (foundJob.sp_status === 'completed') setShowQR(true); }
  }, [sp.data, selMaintId]);

  if (sp.loading || !job) return <div style={{ paddingTop: 40, textAlign: "center" }}><div style={{ color: h.sc, fontSize: 13 }}>{sp.loading ? t.syncingDb : "Job not found"}</div></div>;

  const ten = spTens.find(x => x.id === job.tid); const prop = ten ? spProps.find(x => x.id === ten.pid) : (spProps.length === 1 ? spProps[0] : null);
  const uc = { high: h.rd, med: h.wn, low: h.gn };

  const savePhotosAndNotes = async () => {
    await api.serviceUpdateJob({ id: job.id, sp_notes: notes, photo_before: photoBefore, photo_after: photoAfter });
    flash(t.updated);
  };

  const submitCharges = async () => {
    if (!spPayAmt || Number(spPayAmt) <= 0) { flash(t.enterValidAmount || "Enter a valid amount", "error"); return; }
    const amt = Number(spPayAmt);
    // Use both endpoints — serviceUpdateJob for new servers, saveMaintenance as reliable fallback
    api.serviceUpdateJob({ id: job.id, sp_pay_amt: amt, sp_notes: spPayNotes || notes }).catch(() => {});
    // saveMaintenance does full UPSERT via POST /maintenance — always works
    await api.saveMaintenance({ ...job, sp_pay_amt: amt, sp_pay_st: 'ready', sp_notes: spPayNotes || notes || job.sp_notes });
    setJob({ ...job, sp_pay_amt: amt, sp_pay_st: 'ready' });
    flash(t.chargesSubmitted || "Charges submitted! Landlord will review.");
    // Reload SP data so History/Earnings show updated amounts
    if (sp.reload) sp.reload();
    setTimeout(() => go("spHistory"), 1000);
  };

  const handleComplete = async () => {
    const token = `comp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    await api.serviceUpdateJob({ id: job.id, sp_status: 'completed', completion_token: token, sp_notes: notes, photo_before: photoBefore, photo_after: photoAfter });
    setJob({ ...job, sp_status: 'completed', completion_token: token });
    setShowQR(true);
    flash(t.jobCompleted);
  };

  return <div style={{ paddingTop: 16 }}>
    <button onClick={() => go("spJobs")} style={{ background: "none", border: "none", color: h.ac, cursor: "pointer", fontSize: 13, marginBottom: 8 }}>&larr; {t.back}</button>
    <h2 style={{ color: h.tx, fontSize: 18, fontWeight: 700, margin: "0 0 16px" }}>{t.jobDetails}</h2>
    <div style={crd(h)}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
        <div style={{ color: h.tx, fontWeight: 700, fontSize: 15 }}>{job.desc}</div>
        <span style={bdg(`${uc[job.urg] || h.wn}20`, uc[job.urg] || h.wn)}>{job.urg === "high" ? t.high : job.urg === "med" ? t.med : t.low}</span>
      </div>
      <div style={{ color: h.sc, fontSize: 12 }}>{ten?.name || "General"} · {prop?.addr || "—"}</div>
      <div style={{ color: h.sc, fontSize: 11, marginTop: 4 }}>{t.date}: {job.dt}</div>
      {ten?.ph && <a href={`tel:${ten.ph}`} style={{ color: h.ac, fontSize: 12, marginTop: 4, display: "inline-block" }}>{"📞 " + ten.ph}</a>}
    </div>

    <div style={crd(h)}>
      <PhotoUpload label={t.photoBefore} value={photoBefore} onChange={setPhotoBefore} h={h} />
      <PhotoUpload label={t.photoAfter} value={photoAfter} onChange={setPhotoAfter} h={h} />
      <label style={{ color: h.sc, fontSize: 13, fontWeight: 500, display: "block", marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.5 }}>{t.workNotes}</label>
      <textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder={t.whatWasDone} style={{ ...inpS(h), minHeight: 80, resize: "vertical" }} />
      <button onClick={savePhotosAndNotes} style={btnSec(h)}>{t.save}</button>
    </div>

    {job.sp_status === 'in_progress' && <button onClick={handleComplete} style={{ ...btnP(h), background: h.gn }}>{"✓ " + t.markComplete}</button>}

    {showQR && job.completion_token && <div style={{ ...crd(h), textAlign: "center", padding: 20, marginTop: 12 }}>
      <div style={{ color: h.gn, fontWeight: 600, fontSize: 14, marginBottom: 12 }}>{t.scanToConfirm}</div>
      <div style={{ background: "white", padding: 16, borderRadius: 12, display: "inline-block" }}>
        <QRCode value={JSON.stringify({ type: 'maint_complete', token: job.completion_token, maintId: job.id })} size={180} />
      </div>
      <div style={{ color: h.sc, fontSize: 11, marginTop: 8 }}>{t.showTenantToScan}</div>
      {job.confirmed_by_tenant && <div style={{ background: `${h.gn}15`, padding: 10, borderRadius: 10, marginTop: 12 }}><span style={{ color: h.gn, fontWeight: 600, fontSize: 13 }}>{"✓ " + t.completionVerified}</span></div>}
    </div>}

    {/* Enter Charges — visible when job is completed or done */}
    {(job.sp_status === 'completed' || job.st === 'done') && <div style={{ ...crd(h), marginTop: 12 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
        <span style={{ fontSize: 18 }}>💰</span>
        <div>
          <div style={{ color: h.tx, fontWeight: 700, fontSize: 14 }}>{t.enterCharges || "Enter Your Charges"}</div>
          <div style={{ color: h.sc, fontSize: 11 }}>{t.enterChargesDesc || "Landlord will review and approve payment"}</div>
        </div>
      </div>

      {job.sp_pay_st === 'paid' ? (
        <div style={{ background: `${h.gn}10`, borderRadius: 10, padding: 14, border: `1px solid ${h.gn}30`, textAlign: "center" }}>
          <div style={{ color: h.gn, fontWeight: 700, fontSize: 16 }}>✅ {t.paymentApproved || "Payment Approved!"}</div>
          <div style={{ color: h.gn, fontSize: 20, fontWeight: 700, marginTop: 4 }}>₹{(job.sp_pay_amt || 0).toLocaleString()}</div>
        </div>
      ) : (
        <>
          <label style={{ color: h.sc, fontSize: 12, fontWeight: 500, display: "block", marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.5 }}>{t.totalCharge || "Total Charge (₹)"}</label>
          <div style={{ position: "relative", marginBottom: 12 }}>
            <span style={{ position: "absolute", left: 16, top: "50%", transform: "translateY(-50%)", color: h.tx, fontSize: 16, fontWeight: 700 }}>₹</span>
            <input type="number" value={spPayAmt} onChange={e => setSpPayAmt(e.target.value)} placeholder="0"
              style={{ ...inpS(h), paddingLeft: 36, fontSize: 18, fontWeight: 700, border: `1.5px solid ${h.ac}`, background: `${h.ac}08` }} />
          </div>
          <label style={{ color: h.sc, fontSize: 12, fontWeight: 500, display: "block", marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.5 }}>{t.breakdown || "Breakdown (optional)"}</label>
          <input type="text" value={spPayNotes} onChange={e => setSpPayNotes(e.target.value)} placeholder={t.breakdownPh || "e.g. Parts ₹200 + Labour ₹300"}
            style={{ ...inpS(h), marginBottom: 12, fontSize: 13 }} />

          {job.sp_pay_amt > 0 && job.sp_pay_st === 'ready' && <div style={{ background: `${h.wn}10`, borderRadius: 8, padding: 10, marginBottom: 12, border: `1px solid ${h.wn}30` }}>
            <div style={{ color: h.wn, fontSize: 12, fontWeight: 600 }}>⏳ {t.chargesPending || "Charges submitted — waiting for landlord approval"}</div>
            <div style={{ color: h.tx, fontSize: 16, fontWeight: 700, marginTop: 4 }}>₹{job.sp_pay_amt.toLocaleString()}</div>
          </div>}

          <button onClick={submitCharges} disabled={!spPayAmt || Number(spPayAmt) <= 0}
            style={{ ...btnP(h), background: (!spPayAmt || Number(spPayAmt) <= 0) ? "#9ca3af" : h.ac, opacity: (!spPayAmt || Number(spPayAmt) <= 0) ? 0.5 : 1, cursor: (!spPayAmt || Number(spPayAmt) <= 0) ? "not-allowed" : "pointer" }}>
            {job.sp_pay_amt > 0 ? (t.updateCharges || "Update Charges") : (t.submitCharges || "Submit Charges")}
          </button>
        </>
      )}
    </div>}
  </div>;
}

export default SpJobDetail;
